import { BankIcon } from "Icons/Bank";
import { Building04Icon } from "Icons/Building04";
import { CodeSnippet02Icon } from "Icons/CodeSnippet02";
import { CoinsStacked01Icon } from "Icons/CoinsStacked01";
import { FaceWinkIcon } from "Icons/FaceWink";
import { Globe06Icon } from "Icons/Globe06";
import { GraduationHat02Icon } from "Icons/GraduationHat02";
import { HeartHandIcon } from "Icons/HeartHand";
import { Stars01FilledIcon } from "Icons/Stars01Filled";

import { css } from "@emotion/react";

import { HorizontalSlider } from "components/shared/library/HorizontalSlider";
import { Typography } from "components/shared/library/Typography";

import { down } from "utils/mediaQueryStrings";

import { black, uiGray, white } from "constants/colors";

import { JobSectionCard } from "./JobSectionCard";

const style = {
  card: css({
    borderRadius: 16,
    background: white,
    padding: 24,
    gap: 24,
    display: "flex",
    flexDirection: "column",
  }),
  header: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
    [down("smallMobile")]: { flexWrap: "wrap" },
  }),
  title: css({
    display: "flex",
    flexDirection: "column",
    gap: 8,
    minWidth: "167px",
  }),
  slidingContent: css({
    display: "flex",
    gap: 8,
    width: "fit-content",
  }),
};

export const ExploreJobsSection = () => {
  return (
    <div css={style.card}>
      <div css={style.header}>
        <div css={style.title}>
          <Typography size="L" weight="bold" color={black}>
            Explore jobs
          </Typography>
          <Typography size="XS" color={uiGray[70]}>
            Find your dream job in somewhere least expected.
          </Typography>
        </div>
      </div>
      <HorizontalSlider>
        <div css={style.slidingContent}>
          <JobSectionCard title={"All jobs"} Icon={Building04Icon} />
          <JobSectionCard title={"Remote"} Icon={Globe06Icon} />
          <JobSectionCard title={"Government"} Icon={BankIcon} />
          <JobSectionCard title={"Finance"} Icon={CoinsStacked01Icon} />
          <JobSectionCard title={"Engineering"} Icon={CodeSnippet02Icon} />
          <JobSectionCard title={"Startups"} Icon={Stars01FilledIcon} />
          <JobSectionCard title={"Health"} Icon={HeartHandIcon} />
          <JobSectionCard title={"Internships"} Icon={FaceWinkIcon} />
          <JobSectionCard title={"Education"} Icon={GraduationHat02Icon} />
        </div>
      </HorizontalSlider>
    </div>
  );
};
